import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { useNavigate } from "react-router-dom";
import { Container, Grid, Typography, useTheme } from "@mui/material";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { globalVariables } from "../../global/GlobalVariables";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function StoreAdminIndex() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authContext?.authState?.identity?.isAdmin !== true) {
      navigate("/home");
    }
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!loading && (
        <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h2" gutterBottom>
                Please select a menu option
              </Typography>
            </Grid>
            <Grid item xs={12} textAlign="center">
              <img
                alt={globalVariables()?.site?.title || "Best Coast Pairings"}
                src={`${getEnvironmentVariable(
                  "SYSTEM_IMAGES_CLOUDFRONT"
                )}/images/logo${
                  theme?.palette?.mode === "dark" ? "Dark" : ""
                }.png`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      )}
      {loading && <ModalLoadingFull />}
    </>
  );
}
